import {default as cx} from "classnames"
import {Question} from "./shared/Question"
export function VerticalRadioPrompt({
    options,
    sectionName,
    sectionDescription,
    questionText,
    field,
    questionNumber,
    totalQuestions,
    currentQuestion,
    data,
    emptyError,
    handle,
    isRequired = true,
}) {
    return (
        <>
            <Question
                questionText={questionText}
                questionNumber={questionNumber}
                totalQuestions={totalQuestions}
                isRequired={isRequired}
            />
            <div className="d-flex flex-column flex-md-stack gap-6 py-5">
                {options.map((option, index) => {
                    const id = `${field}-${index}`
                    const checked = option.value === data
                    return (
                        <div className="w-100" key={index}>
                            <input
                                id={id}
                                type="radio"
                                className="btn-check"
                                name={field}
                                value={option.value}
                                checked={checked}
                                onChange={(evt) => handle(evt.target.value)}
                            />
                            <label
                                className={cx(
                                    "btn btn-flex btn-light btn-active-primary border border-1 w-100",
                                    emptyError ? "border-danger" : "border-primary",
                                    {active: checked}
                                )}
                                htmlFor={id}
                            >
                                {option.label}
                            </label>
                        </div>
                    )
                })}
            </div>
            {emptyError && isRequired && <span className="text-danger mt-n5">Selection is required</span>}
        </>
    )
}
